import { clientDayKey } from '../../shared/dateTime';

/**
 * Terminy uprawnień i alertów pojazdu z kartoteki TMS — czysta logika
 * (07.10.2026, prototyp p. Mariusza, zmiana 16). Wspólna dla sekcji
 * „Uprawnienia i alerty” i pola „Najbliższy termin” w podsumowaniu karty.
 */

/** Wpis z `GET /cars/:id` — surowo z kartoteki TMS (od 01.10.2026). */
export interface VehicleEligibilityRow {
  name: string;
  /** `Blokada` / `Alert` — klasyfikacja klienta. */
  type: string | null;
  /** `true` = ważne, `false` = nieważne (odpowiedź Marathonu 16.10.2026, pyt. 8). */
  status: boolean | null;
  validUpTo: string | null;
  importedAt: string | null;
  /** Definicja uprawnienia — „Zmień termin” (korekty kartoteki, 22.10.2026). */
  eligibilityId?: number;
  /**
   * Korekta terminu w aplikacji (22.10.2026, `fleetCorrections`): wtedy
   * `validUpTo` to termin po korekcie, a obok wartość z TMS. Status z TMS
   * dotyczy terminu z TMS, więc przy korekcie `status` jest pusty.
   */
  correctionId?: number;
  tmsValidUpTo?: string | null;
  tmsStatus?: boolean | null;
}

/** Ile dni do terminu-DATY od dzisiejszego dnia polskiego; ujemne — minął; brak — `null`. */
export function daysUntil(iso: string | null | undefined, now: Date = new Date()): number | null {
  if (!iso) return null;
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return null;
  const [y, m, day] = clientDayKey(now).split('-').map(Number);
  const target = Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
  return Math.round((target - Date.UTC(y, m - 1, day)) / 86_400_000);
}

/** Termin w ciągu tylu dni (i każdy wygasły) jest wyróżniony i zawsze widoczny (prototyp, zmiana 16). */
export const SOON_DAYS = 30;

/** Od najbliższego terminu; bez terminu — na końcu, po nazwie. */
export function sortByTerm(rows: readonly VehicleEligibilityRow[]): VehicleEligibilityRow[] {
  const t = (e: VehicleEligibilityRow) => {
    const ms = e.validUpTo ? new Date(e.validUpTo).getTime() : NaN;
    return Number.isNaN(ms) ? Infinity : ms;
  };
  return [...rows].sort((a, b) => t(a) - t(b) || a.name.localeCompare(b.name, 'pl'));
}

